/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as UnauthRouteImport } from './routes/_unauth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as UnauthRegisterRouteImport } from './routes/_unauth/register'
import { Route as UnauthLoginRouteImport } from './routes/_unauth/login'
import { Route as AuthThemePreviewRouteImport } from './routes/_auth/theme-preview'
import { Route as AuthTeamEvaluationRouteImport } from './routes/_auth/team-evaluation'
import { Route as AuthTeamCoursesRouteImport } from './routes/_auth/team-courses'
import { Route as AuthSignDocumentsRouteImport } from './routes/_auth/sign-documents'
import { Route as AuthSigRouteImport } from './routes/_auth/sig'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthResultsRouteImport } from './routes/_auth/results'
import { Route as AuthReportsRouteImport } from './routes/_auth/reports'
import { Route as AuthProjectionsRouteImport } from './routes/_auth/projections'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthPeopleRouteImport } from './routes/_auth/people'
import { Route as AuthOrgchartRouteImport } from './routes/_auth/orgchart'
import { Route as AuthMyTeamRouteImport } from './routes/_auth/my-team'
import { Route as AuthMyOnboardingRouteImport } from './routes/_auth/my-onboarding'
import { Route as AuthMyEvaluationRouteImport } from './routes/_auth/my-evaluation'
import { Route as AuthMyCoursesRouteImport } from './routes/_auth/my-courses'
import { Route as AuthMyBusinessTargetsRouteImport } from './routes/_auth/my-business-targets'
import { Route as AuthMetasGestaoRouteImport } from './routes/_auth/metas-gestao'
import { Route as AuthJanesRouteImport } from './routes/_auth/janes'
import { Route as AuthFinancialRouteImport } from './routes/_auth/financial'
import { Route as AuthEmployeesRouteImport } from './routes/_auth/employees'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthConfigRouteImport } from './routes/_auth/config'
import { Route as AuthComponentShowcaseRouteImport } from './routes/_auth/component-showcase'
import { Route as AuthCalendarRouteImport } from './routes/_auth/calendar'
import { Route as AuthAvailableBudgetRouteImport } from './routes/_auth/available-budget'
import { Route as AuthVacationIndexRouteImport } from './routes/_auth/vacation/index'
import { Route as AuthTrainingIndexRouteImport } from './routes/_auth/training/index'
import { Route as AuthRevfinopsIndexRouteImport } from './routes/_auth/revfinops/index'
import { Route as AuthRecruitmentIndexRouteImport } from './routes/_auth/recruitment/index'
import { Route as AuthPerformanceIndexRouteImport } from './routes/_auth/performance/index'
import { Route as AuthOnboardingIndexRouteImport } from './routes/_auth/onboarding/index'
import { Route as AuthFinancialIndexRouteImport } from './routes/_auth/financial/index'
import { Route as AuthDocumentsIndexRouteImport } from './routes/_auth/documents/index'
import { Route as AuthClientsIndexRouteImport } from './routes/_auth/clients/index'
import { Route as PublicSTokenRouteImport } from './routes/_public/s/$token'
import { Route as AuthWorkforcePayrollRouteImport } from './routes/_auth/workforce/payroll'
import { Route as AuthWorkforceAuditLogsRouteImport } from './routes/_auth/workforce/audit-logs'
import { Route as AuthVacationRequestsRouteImport } from './routes/_auth/vacation/requests'
import { Route as AuthVacationRequestRouteImport } from './routes/_auth/vacation/request'
import { Route as AuthVacationOverviewRouteImport } from './routes/_auth/vacation/overview'
import { Route as AuthVacationCalendarRouteImport } from './routes/_auth/vacation/calendar'
import { Route as AuthVacationApprovalsRouteImport } from './routes/_auth/vacation/approvals'
import { Route as AuthUsersIdRouteImport } from './routes/_auth/users/$id'
import { Route as AuthTrainingNewRouteImport } from './routes/_auth/training/new'
import { Route as AuthRevfinopsPayablesRouteImport } from './routes/_auth/revfinops/payables'
import { Route as AuthRecruitmentNewRouteImport } from './routes/_auth/recruitment/new'
import { Route as AuthPerformanceOkrsRouteImport } from './routes/_auth/performance/okrs'
import { Route as AuthPerformanceNewRouteImport } from './routes/_auth/performance/new'
import { Route as AuthPerformanceIndividualRouteImport } from './routes/_auth/performance/individual'
import { Route as AuthPerformanceGuiaRouteImport } from './routes/_auth/performance/guia'
import { Route as AuthPerformanceClimaRouteImport } from './routes/_auth/performance/clima'
import { Route as AuthOnboardingIdRouteImport } from './routes/_auth/onboarding/$id'
import { Route as AuthNotificationsPreferencesRouteImport } from './routes/_auth/notifications/preferences'
import { Route as AuthMeetingsScheduleRouteImport } from './routes/_auth/meetings/schedule'
import { Route as AuthGroupsGroupIdRouteImport } from './routes/_auth/groups/$groupId'
import { Route as AuthFinancialProaRouteImport } from './routes/_auth/financial/proa'
import { Route as AuthFinancialPerformanceClientesRouteImport } from './routes/_auth/financial/performance-clientes'
import { Route as AuthFinancialDashboardRouteImport } from './routes/_auth/financial/dashboard'
import { Route as AuthFinancialClientMatrixMockRouteImport } from './routes/_auth/financial/client-matrix-mock'
import { Route as AuthFinancialClientMatrixInteractiveRouteImport } from './routes/_auth/financial/client-matrix-interactive'
import { Route as AuthFinancialClientDetailInteractiveRouteImport } from './routes/_auth/financial/client-detail-interactive'
import { Route as AuthFinancialClientDetailRouteImport } from './routes/_auth/financial/client-detail'
import { Route as AuthFinancialBigNumbersRouteImport } from './routes/_auth/financial/big-numbers'
import { Route as AuthFinancialAccountsReceivableRouteImport } from './routes/_auth/financial/accounts-receivable'
import { Route as AuthFinancialAccountsPayableRouteImport } from './routes/_auth/financial/accounts-payable'
import { Route as AuthDocumentsIdRouteImport } from './routes/_auth/documents/$id'
import { Route as AuthDesignSystemAnalyticsShowcaseRouteImport } from './routes/_auth/design-system.analytics-showcase'
import { Route as AuthDesignSystemAnalyticsDashboardRouteImport } from './routes/_auth/design-system.analytics-dashboard'
import { Route as AuthWorkforceRolesIndexRouteImport } from './routes/_auth/workforce/roles/index'
import { Route as AuthWorkforceEmployeesIndexRouteImport } from './routes/_auth/workforce/employees/index'
import { Route as AuthWorkforceDepartmentsIndexRouteImport } from './routes/_auth/workforce/departments.index'
import { Route as AuthSigClientsIndexRouteImport } from './routes/_auth/sig/clients/index'
import { Route as AuthRevfinopsClientsIndexRouteImport } from './routes/_auth/revfinops/clients/index'
import { Route as AuthPerformanceFeedbacksIndexRouteImport } from './routes/_auth/performance/feedbacks/index'
import { Route as AuthPerformanceConfiguracoesIndexRouteImport } from './routes/_auth/performance/configuracoes/index'
import { Route as AuthPerformanceAvaliacoesIndexRouteImport } from './routes/_auth/performance/avaliacoes/index'
import { Route as AuthFinancialDreIndexRouteImport } from './routes/_auth/financial/dre.index'
import { Route as AuthFinancialClientMatrixIndexRouteImport } from './routes/_auth/financial/client-matrix/index'
import { Route as AuthFinancialBuMatrixIndexRouteImport } from './routes/_auth/financial/bu-matrix/index'
import { Route as AuthWorkforceRolesNewRouteImport } from './routes/_auth/workforce/roles/new'
import { Route as AuthWorkforceEmployeesNewRouteImport } from './routes/_auth/workforce/employees/new'
import { Route as AuthWorkforceDepartmentsNewRouteImport } from './routes/_auth/workforce/departments/new'
import { Route as AuthUsersIdEditRouteImport } from './routes/_auth/users/$id.edit'
import { Route as AuthTemplatesIdUseRouteImport } from './routes/_auth/templates/$id.use'
import { Route as AuthRevfinopsClientsNewRouteImport } from './routes/_auth/revfinops/clients/new'
import { Route as AuthPerformanceFeedbacksReceivedRouteImport } from './routes/_auth/performance/feedbacks/received'
import { Route as AuthPerformanceFeedbacksQuickRouteImport } from './routes/_auth/performance/feedbacks/quick'
import { Route as AuthPerformanceFeedbacksCompleteRouteImport } from './routes/_auth/performance/feedbacks/complete'
import { Route as AuthPerformanceConfiguracoesParametrosRouteImport } from './routes/_auth/performance/configuracoes/parametros'
import { Route as AuthPerformanceConfiguracoesMatrizRouteImport } from './routes/_auth/performance/configuracoes/matriz'
import { Route as AuthPerformanceAvaliacoesFormRouteImport } from './routes/_auth/performance/avaliacoes/form'
import { Route as AuthFinancialClientMatrixClientIdRouteImport } from './routes/_auth/financial/client-matrix/$clientId'
import { Route as AuthFinancialBuMatrixBuIdRouteImport } from './routes/_auth/financial/bu-matrix/$buId'
import { Route as AuthDocumentsIdAuditRouteImport } from './routes/_auth/documents/$id.audit'
import { Route as AuthClientsClientCodeDashboardRouteImport } from './routes/_auth/clients/$clientCode/dashboard'
import { Route as AuthWorkforceRolesRoleIdIndexRouteImport } from './routes/_auth/workforce/roles/$roleId/index'
import { Route as AuthWorkforceEmployeesEmployeeIdIndexRouteImport } from './routes/_auth/workforce/employees/$employeeId/index'
import { Route as AuthWorkforceDepartmentsDepartmentIdIndexRouteImport } from './routes/_auth/workforce/departments/$departmentId/index'
import { Route as AuthWorkforceRolesRoleIdEditRouteImport } from './routes/_auth/workforce/roles/$roleId/edit'
import { Route as AuthWorkforceEmployeesEmployeeIdEditRouteImport } from './routes/_auth/workforce/employees/$employeeId/edit'
import { Route as AuthWorkforceDepartmentsDepartmentIdEditRouteImport } from './routes/_auth/workforce/departments/$departmentId/edit'
import { Route as AuthFinancialDreDrilldownLineItemRouteImport } from './routes/_auth/financial/dre.drilldown.$lineItem'

const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthRoute = UnauthRouteImport.update({
  id: '/_unauth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const UnauthRegisterRoute = UnauthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => UnauthRoute,
} as any)
const UnauthLoginRoute = UnauthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthRoute,
} as any)
const AuthThemePreviewRoute = AuthThemePreviewRouteImport.update({
  id: '/theme-preview',
  path: '/theme-preview',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTeamEvaluationRoute = AuthTeamEvaluationRouteImport.update({
  id: '/team-evaluation',
  path: '/team-evaluation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTeamCoursesRoute = AuthTeamCoursesRouteImport.update({
  id: '/team-courses',
  path: '/team-courses',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignDocumentsRoute = AuthSignDocumentsRouteImport.update({
  id: '/sign-documents',
  path: '/sign-documents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigRoute = AuthSigRouteImport.update({
  id: '/sig',
  path: '/sig',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResultsRoute = AuthResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectionsRoute = AuthProjectionsRouteImport.update({
  id: '/projections',
  path: '/projections',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPeopleRoute = AuthPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrgchartRoute = AuthOrgchartRouteImport.update({
  id: '/orgchart',
  path: '/orgchart',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyTeamRoute = AuthMyTeamRouteImport.update({
  id: '/my-team',
  path: '/my-team',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyOnboardingRoute = AuthMyOnboardingRouteImport.update({
  id: '/my-onboarding',
  path: '/my-onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyEvaluationRoute = AuthMyEvaluationRouteImport.update({
  id: '/my-evaluation',
  path: '/my-evaluation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyCoursesRoute = AuthMyCoursesRouteImport.update({
  id: '/my-courses',
  path: '/my-courses',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyBusinessTargetsRoute = AuthMyBusinessTargetsRouteImport.update({
  id: '/my-business-targets',
  path: '/my-business-targets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMetasGestaoRoute = AuthMetasGestaoRouteImport.update({
  id: '/metas-gestao',
  path: '/metas-gestao',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJanesRoute = AuthJanesRouteImport.update({
  id: '/janes',
  path: '/janes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinancialRoute = AuthFinancialRouteImport.update({
  id: '/financial',
  path: '/financial',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmployeesRoute = AuthEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfigRoute = AuthConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthRoute,
} as any)
const AuthComponentShowcaseRoute = AuthComponentShowcaseRouteImport.update({
  id: '/component-showcase',
  path: '/component-showcase',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalendarRoute = AuthCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAvailableBudgetRoute = AuthAvailableBudgetRouteImport.update({
  id: '/available-budget',
  path: '/available-budget',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationIndexRoute = AuthVacationIndexRouteImport.update({
  id: '/vacation/',
  path: '/vacation/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTrainingIndexRoute = AuthTrainingIndexRouteImport.update({
  id: '/training/',
  path: '/training/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRevfinopsIndexRoute = AuthRevfinopsIndexRouteImport.update({
  id: '/revfinops/',
  path: '/revfinops/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecruitmentIndexRoute = AuthRecruitmentIndexRouteImport.update({
  id: '/recruitment/',
  path: '/recruitment/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceIndexRoute = AuthPerformanceIndexRouteImport.update({
  id: '/performance/',
  path: '/performance/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingIndexRoute = AuthOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinancialIndexRoute = AuthFinancialIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthFinancialRoute,
} as any)
const AuthDocumentsIndexRoute = AuthDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsIndexRoute = AuthClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicSTokenRoute = PublicSTokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => PublicRoute,
} as any)
const AuthWorkforcePayrollRoute = AuthWorkforcePayrollRouteImport.update({
  id: '/workforce/payroll',
  path: '/workforce/payroll',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkforceAuditLogsRoute = AuthWorkforceAuditLogsRouteImport.update({
  id: '/workforce/audit-logs',
  path: '/workforce/audit-logs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationRequestsRoute = AuthVacationRequestsRouteImport.update({
  id: '/vacation/requests',
  path: '/vacation/requests',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationRequestRoute = AuthVacationRequestRouteImport.update({
  id: '/vacation/request',
  path: '/vacation/request',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationOverviewRoute = AuthVacationOverviewRouteImport.update({
  id: '/vacation/overview',
  path: '/vacation/overview',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationCalendarRoute = AuthVacationCalendarRouteImport.update({
  id: '/vacation/calendar',
  path: '/vacation/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVacationApprovalsRoute = AuthVacationApprovalsRouteImport.update({
  id: '/vacation/approvals',
  path: '/vacation/approvals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIdRoute = AuthUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTrainingNewRoute = AuthTrainingNewRouteImport.update({
  id: '/training/new',
  path: '/training/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRevfinopsPayablesRoute = AuthRevfinopsPayablesRouteImport.update({
  id: '/revfinops/payables',
  path: '/revfinops/payables',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecruitmentNewRoute = AuthRecruitmentNewRouteImport.update({
  id: '/recruitment/new',
  path: '/recruitment/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceOkrsRoute = AuthPerformanceOkrsRouteImport.update({
  id: '/performance/okrs',
  path: '/performance/okrs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceNewRoute = AuthPerformanceNewRouteImport.update({
  id: '/performance/new',
  path: '/performance/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceIndividualRoute =
  AuthPerformanceIndividualRouteImport.update({
    id: '/performance/individual',
    path: '/performance/individual',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceGuiaRoute = AuthPerformanceGuiaRouteImport.update({
  id: '/performance/guia',
  path: '/performance/guia',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceClimaRoute = AuthPerformanceClimaRouteImport.update({
  id: '/performance/clima',
  path: '/performance/clima',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingIdRoute = AuthOnboardingIdRouteImport.update({
  id: '/onboarding/$id',
  path: '/onboarding/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNotificationsPreferencesRoute =
  AuthNotificationsPreferencesRouteImport.update({
    id: '/notifications/preferences',
    path: '/notifications/preferences',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMeetingsScheduleRoute = AuthMeetingsScheduleRouteImport.update({
  id: '/meetings/schedule',
  path: '/meetings/schedule',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGroupsGroupIdRoute = AuthGroupsGroupIdRouteImport.update({
  id: '/groups/$groupId',
  path: '/groups/$groupId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinancialProaRoute = AuthFinancialProaRouteImport.update({
  id: '/proa',
  path: '/proa',
  getParentRoute: () => AuthFinancialRoute,
} as any)
const AuthFinancialPerformanceClientesRoute =
  AuthFinancialPerformanceClientesRouteImport.update({
    id: '/performance-clientes',
    path: '/performance-clientes',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialDashboardRoute = AuthFinancialDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthFinancialRoute,
} as any)
const AuthFinancialClientMatrixMockRoute =
  AuthFinancialClientMatrixMockRouteImport.update({
    id: '/client-matrix-mock',
    path: '/client-matrix-mock',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialClientMatrixInteractiveRoute =
  AuthFinancialClientMatrixInteractiveRouteImport.update({
    id: '/client-matrix-interactive',
    path: '/client-matrix-interactive',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialClientDetailInteractiveRoute =
  AuthFinancialClientDetailInteractiveRouteImport.update({
    id: '/client-detail-interactive',
    path: '/client-detail-interactive',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialClientDetailRoute =
  AuthFinancialClientDetailRouteImport.update({
    id: '/client-detail',
    path: '/client-detail',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialBigNumbersRoute = AuthFinancialBigNumbersRouteImport.update({
  id: '/big-numbers',
  path: '/big-numbers',
  getParentRoute: () => AuthFinancialRoute,
} as any)
const AuthFinancialAccountsReceivableRoute =
  AuthFinancialAccountsReceivableRouteImport.update({
    id: '/accounts-receivable',
    path: '/accounts-receivable',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialAccountsPayableRoute =
  AuthFinancialAccountsPayableRouteImport.update({
    id: '/accounts-payable',
    path: '/accounts-payable',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthDocumentsIdRoute = AuthDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDesignSystemAnalyticsShowcaseRoute =
  AuthDesignSystemAnalyticsShowcaseRouteImport.update({
    id: '/design-system/analytics-showcase',
    path: '/design-system/analytics-showcase',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDesignSystemAnalyticsDashboardRoute =
  AuthDesignSystemAnalyticsDashboardRouteImport.update({
    id: '/design-system/analytics-dashboard',
    path: '/design-system/analytics-dashboard',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceRolesIndexRoute = AuthWorkforceRolesIndexRouteImport.update({
  id: '/workforce/roles/',
  path: '/workforce/roles/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkforceEmployeesIndexRoute =
  AuthWorkforceEmployeesIndexRouteImport.update({
    id: '/workforce/employees/',
    path: '/workforce/employees/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceDepartmentsIndexRoute =
  AuthWorkforceDepartmentsIndexRouteImport.update({
    id: '/workforce/departments/',
    path: '/workforce/departments/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSigClientsIndexRoute = AuthSigClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthSigRoute,
} as any)
const AuthRevfinopsClientsIndexRoute =
  AuthRevfinopsClientsIndexRouteImport.update({
    id: '/revfinops/clients/',
    path: '/revfinops/clients/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceFeedbacksIndexRoute =
  AuthPerformanceFeedbacksIndexRouteImport.update({
    id: '/performance/feedbacks/',
    path: '/performance/feedbacks/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceConfiguracoesIndexRoute =
  AuthPerformanceConfiguracoesIndexRouteImport.update({
    id: '/performance/configuracoes/',
    path: '/performance/configuracoes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceAvaliacoesIndexRoute =
  AuthPerformanceAvaliacoesIndexRouteImport.update({
    id: '/performance/avaliacoes/',
    path: '/performance/avaliacoes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinancialDreIndexRoute = AuthFinancialDreIndexRouteImport.update({
  id: '/dre/',
  path: '/dre/',
  getParentRoute: () => AuthFinancialRoute,
} as any)
const AuthFinancialClientMatrixIndexRoute =
  AuthFinancialClientMatrixIndexRouteImport.update({
    id: '/client-matrix/',
    path: '/client-matrix/',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialBuMatrixIndexRoute =
  AuthFinancialBuMatrixIndexRouteImport.update({
    id: '/bu-matrix/',
    path: '/bu-matrix/',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthWorkforceRolesNewRoute = AuthWorkforceRolesNewRouteImport.update({
  id: '/workforce/roles/new',
  path: '/workforce/roles/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkforceEmployeesNewRoute =
  AuthWorkforceEmployeesNewRouteImport.update({
    id: '/workforce/employees/new',
    path: '/workforce/employees/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceDepartmentsNewRoute =
  AuthWorkforceDepartmentsNewRouteImport.update({
    id: '/workforce/departments/new',
    path: '/workforce/departments/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthUsersIdEditRoute = AuthUsersIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthUsersIdRoute,
} as any)
const AuthTemplatesIdUseRoute = AuthTemplatesIdUseRouteImport.update({
  id: '/templates/$id/use',
  path: '/templates/$id/use',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRevfinopsClientsNewRoute = AuthRevfinopsClientsNewRouteImport.update({
  id: '/revfinops/clients/new',
  path: '/revfinops/clients/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceFeedbacksReceivedRoute =
  AuthPerformanceFeedbacksReceivedRouteImport.update({
    id: '/performance/feedbacks/received',
    path: '/performance/feedbacks/received',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceFeedbacksQuickRoute =
  AuthPerformanceFeedbacksQuickRouteImport.update({
    id: '/performance/feedbacks/quick',
    path: '/performance/feedbacks/quick',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceFeedbacksCompleteRoute =
  AuthPerformanceFeedbacksCompleteRouteImport.update({
    id: '/performance/feedbacks/complete',
    path: '/performance/feedbacks/complete',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceConfiguracoesParametrosRoute =
  AuthPerformanceConfiguracoesParametrosRouteImport.update({
    id: '/performance/configuracoes/parametros',
    path: '/performance/configuracoes/parametros',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceConfiguracoesMatrizRoute =
  AuthPerformanceConfiguracoesMatrizRouteImport.update({
    id: '/performance/configuracoes/matriz',
    path: '/performance/configuracoes/matriz',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceAvaliacoesFormRoute =
  AuthPerformanceAvaliacoesFormRouteImport.update({
    id: '/performance/avaliacoes/form',
    path: '/performance/avaliacoes/form',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinancialClientMatrixClientIdRoute =
  AuthFinancialClientMatrixClientIdRouteImport.update({
    id: '/client-matrix/$clientId',
    path: '/client-matrix/$clientId',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthFinancialBuMatrixBuIdRoute =
  AuthFinancialBuMatrixBuIdRouteImport.update({
    id: '/bu-matrix/$buId',
    path: '/bu-matrix/$buId',
    getParentRoute: () => AuthFinancialRoute,
  } as any)
const AuthDocumentsIdAuditRoute = AuthDocumentsIdAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthDocumentsIdRoute,
} as any)
const AuthClientsClientCodeDashboardRoute =
  AuthClientsClientCodeDashboardRouteImport.update({
    id: '/clients/$clientCode/dashboard',
    path: '/clients/$clientCode/dashboard',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceRolesRoleIdIndexRoute =
  AuthWorkforceRolesRoleIdIndexRouteImport.update({
    id: '/workforce/roles/$roleId/',
    path: '/workforce/roles/$roleId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceEmployeesEmployeeIdIndexRoute =
  AuthWorkforceEmployeesEmployeeIdIndexRouteImport.update({
    id: '/workforce/employees/$employeeId/',
    path: '/workforce/employees/$employeeId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceDepartmentsDepartmentIdIndexRoute =
  AuthWorkforceDepartmentsDepartmentIdIndexRouteImport.update({
    id: '/workforce/departments/$departmentId/',
    path: '/workforce/departments/$departmentId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceRolesRoleIdEditRoute =
  AuthWorkforceRolesRoleIdEditRouteImport.update({
    id: '/workforce/roles/$roleId/edit',
    path: '/workforce/roles/$roleId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceEmployeesEmployeeIdEditRoute =
  AuthWorkforceEmployeesEmployeeIdEditRouteImport.update({
    id: '/workforce/employees/$employeeId/edit',
    path: '/workforce/employees/$employeeId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkforceDepartmentsDepartmentIdEditRoute =
  AuthWorkforceDepartmentsDepartmentIdEditRouteImport.update({
    id: '/workforce/departments/$departmentId/edit',
    path: '/workforce/departments/$departmentId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinancialDreDrilldownLineItemRoute =
  AuthFinancialDreDrilldownLineItemRouteImport.update({
    id: '/dre/drilldown/$lineItem',
    path: '/dre/drilldown/$lineItem',
    getParentRoute: () => AuthFinancialRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/error': typeof ErrorRoute
  '/available-budget': typeof AuthAvailableBudgetRoute
  '/calendar': typeof AuthCalendarRoute
  '/component-showcase': typeof AuthComponentShowcaseRoute
  '/config': typeof AuthConfigRoute
  '/dashboard': typeof AuthDashboardRoute
  '/employees': typeof AuthEmployeesRoute
  '/financial': typeof AuthFinancialRouteWithChildren
  '/janes': typeof AuthJanesRoute
  '/metas-gestao': typeof AuthMetasGestaoRoute
  '/my-business-targets': typeof AuthMyBusinessTargetsRoute
  '/my-courses': typeof AuthMyCoursesRoute
  '/my-evaluation': typeof AuthMyEvaluationRoute
  '/my-onboarding': typeof AuthMyOnboardingRoute
  '/my-team': typeof AuthMyTeamRoute
  '/orgchart': typeof AuthOrgchartRoute
  '/people': typeof AuthPeopleRoute
  '/profile': typeof AuthProfileRoute
  '/projections': typeof AuthProjectionsRoute
  '/reports': typeof AuthReportsRoute
  '/results': typeof AuthResultsRoute
  '/settings': typeof AuthSettingsRoute
  '/sig': typeof AuthSigRouteWithChildren
  '/sign-documents': typeof AuthSignDocumentsRoute
  '/team-courses': typeof AuthTeamCoursesRoute
  '/team-evaluation': typeof AuthTeamEvaluationRoute
  '/theme-preview': typeof AuthThemePreviewRoute
  '/login': typeof UnauthLoginRoute
  '/register': typeof UnauthRegisterRoute
  '/': typeof AuthIndexRoute
  '/design-system/analytics-dashboard': typeof AuthDesignSystemAnalyticsDashboardRoute
  '/design-system/analytics-showcase': typeof AuthDesignSystemAnalyticsShowcaseRoute
  '/documents/$id': typeof AuthDocumentsIdRouteWithChildren
  '/financial/accounts-payable': typeof AuthFinancialAccountsPayableRoute
  '/financial/accounts-receivable': typeof AuthFinancialAccountsReceivableRoute
  '/financial/big-numbers': typeof AuthFinancialBigNumbersRoute
  '/financial/client-detail': typeof AuthFinancialClientDetailRoute
  '/financial/client-detail-interactive': typeof AuthFinancialClientDetailInteractiveRoute
  '/financial/client-matrix-interactive': typeof AuthFinancialClientMatrixInteractiveRoute
  '/financial/client-matrix-mock': typeof AuthFinancialClientMatrixMockRoute
  '/financial/dashboard': typeof AuthFinancialDashboardRoute
  '/financial/performance-clientes': typeof AuthFinancialPerformanceClientesRoute
  '/financial/proa': typeof AuthFinancialProaRoute
  '/groups/$groupId': typeof AuthGroupsGroupIdRoute
  '/meetings/schedule': typeof AuthMeetingsScheduleRoute
  '/notifications/preferences': typeof AuthNotificationsPreferencesRoute
  '/onboarding/$id': typeof AuthOnboardingIdRoute
  '/performance/clima': typeof AuthPerformanceClimaRoute
  '/performance/guia': typeof AuthPerformanceGuiaRoute
  '/performance/individual': typeof AuthPerformanceIndividualRoute
  '/performance/new': typeof AuthPerformanceNewRoute
  '/performance/okrs': typeof AuthPerformanceOkrsRoute
  '/recruitment/new': typeof AuthRecruitmentNewRoute
  '/revfinops/payables': typeof AuthRevfinopsPayablesRoute
  '/training/new': typeof AuthTrainingNewRoute
  '/users/$id': typeof AuthUsersIdRouteWithChildren
  '/vacation/approvals': typeof AuthVacationApprovalsRoute
  '/vacation/calendar': typeof AuthVacationCalendarRoute
  '/vacation/overview': typeof AuthVacationOverviewRoute
  '/vacation/request': typeof AuthVacationRequestRoute
  '/vacation/requests': typeof AuthVacationRequestsRoute
  '/workforce/audit-logs': typeof AuthWorkforceAuditLogsRoute
  '/workforce/payroll': typeof AuthWorkforcePayrollRoute
  '/s/$token': typeof PublicSTokenRoute
  '/clients': typeof AuthClientsIndexRoute
  '/documents': typeof AuthDocumentsIndexRoute
  '/financial/': typeof AuthFinancialIndexRoute
  '/onboarding': typeof AuthOnboardingIndexRoute
  '/performance': typeof AuthPerformanceIndexRoute
  '/recruitment': typeof AuthRecruitmentIndexRoute
  '/revfinops': typeof AuthRevfinopsIndexRoute
  '/training': typeof AuthTrainingIndexRoute
  '/vacation': typeof AuthVacationIndexRoute
  '/clients/$clientCode/dashboard': typeof AuthClientsClientCodeDashboardRoute
  '/documents/$id/audit': typeof AuthDocumentsIdAuditRoute
  '/financial/bu-matrix/$buId': typeof AuthFinancialBuMatrixBuIdRoute
  '/financial/client-matrix/$clientId': typeof AuthFinancialClientMatrixClientIdRoute
  '/performance/avaliacoes/form': typeof AuthPerformanceAvaliacoesFormRoute
  '/performance/configuracoes/matriz': typeof AuthPerformanceConfiguracoesMatrizRoute
  '/performance/configuracoes/parametros': typeof AuthPerformanceConfiguracoesParametrosRoute
  '/performance/feedbacks/complete': typeof AuthPerformanceFeedbacksCompleteRoute
  '/performance/feedbacks/quick': typeof AuthPerformanceFeedbacksQuickRoute
  '/performance/feedbacks/received': typeof AuthPerformanceFeedbacksReceivedRoute
  '/revfinops/clients/new': typeof AuthRevfinopsClientsNewRoute
  '/templates/$id/use': typeof AuthTemplatesIdUseRoute
  '/users/$id/edit': typeof AuthUsersIdEditRoute
  '/workforce/departments/new': typeof AuthWorkforceDepartmentsNewRoute
  '/workforce/employees/new': typeof AuthWorkforceEmployeesNewRoute
  '/workforce/roles/new': typeof AuthWorkforceRolesNewRoute
  '/financial/bu-matrix': typeof AuthFinancialBuMatrixIndexRoute
  '/financial/client-matrix': typeof AuthFinancialClientMatrixIndexRoute
  '/financial/dre': typeof AuthFinancialDreIndexRoute
  '/performance/avaliacoes': typeof AuthPerformanceAvaliacoesIndexRoute
  '/performance/configuracoes': typeof AuthPerformanceConfiguracoesIndexRoute
  '/performance/feedbacks': typeof AuthPerformanceFeedbacksIndexRoute
  '/revfinops/clients': typeof AuthRevfinopsClientsIndexRoute
  '/sig/clients': typeof AuthSigClientsIndexRoute
  '/workforce/departments': typeof AuthWorkforceDepartmentsIndexRoute
  '/workforce/employees': typeof AuthWorkforceEmployeesIndexRoute
  '/workforce/roles': typeof AuthWorkforceRolesIndexRoute
  '/financial/dre/drilldown/$lineItem': typeof AuthFinancialDreDrilldownLineItemRoute
  '/workforce/departments/$departmentId/edit': typeof AuthWorkforceDepartmentsDepartmentIdEditRoute
  '/workforce/employees/$employeeId/edit': typeof AuthWorkforceEmployeesEmployeeIdEditRoute
  '/workforce/roles/$roleId/edit': typeof AuthWorkforceRolesRoleIdEditRoute
  '/workforce/departments/$departmentId': typeof AuthWorkforceDepartmentsDepartmentIdIndexRoute
  '/workforce/employees/$employeeId': typeof AuthWorkforceEmployeesEmployeeIdIndexRoute
  '/workforce/roles/$roleId': typeof AuthWorkforceRolesRoleIdIndexRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/available-budget': typeof AuthAvailableBudgetRoute
  '/calendar': typeof AuthCalendarRoute
  '/component-showcase': typeof AuthComponentShowcaseRoute
  '/config': typeof AuthConfigRoute
  '/dashboard': typeof AuthDashboardRoute
  '/employees': typeof AuthEmployeesRoute
  '/janes': typeof AuthJanesRoute
  '/metas-gestao': typeof AuthMetasGestaoRoute
  '/my-business-targets': typeof AuthMyBusinessTargetsRoute
  '/my-courses': typeof AuthMyCoursesRoute
  '/my-evaluation': typeof AuthMyEvaluationRoute
  '/my-onboarding': typeof AuthMyOnboardingRoute
  '/my-team': typeof AuthMyTeamRoute
  '/orgchart': typeof AuthOrgchartRoute
  '/people': typeof AuthPeopleRoute
  '/profile': typeof AuthProfileRoute
  '/projections': typeof AuthProjectionsRoute
  '/reports': typeof AuthReportsRoute
  '/results': typeof AuthResultsRoute
  '/settings': typeof AuthSettingsRoute
  '/sig': typeof AuthSigRouteWithChildren
  '/sign-documents': typeof AuthSignDocumentsRoute
  '/team-courses': typeof AuthTeamCoursesRoute
  '/team-evaluation': typeof AuthTeamEvaluationRoute
  '/theme-preview': typeof AuthThemePreviewRoute
  '/login': typeof UnauthLoginRoute
  '/register': typeof UnauthRegisterRoute
  '/': typeof AuthIndexRoute
  '/design-system/analytics-dashboard': typeof AuthDesignSystemAnalyticsDashboardRoute
  '/design-system/analytics-showcase': typeof AuthDesignSystemAnalyticsShowcaseRoute
  '/documents/$id': typeof AuthDocumentsIdRouteWithChildren
  '/financial/accounts-payable': typeof AuthFinancialAccountsPayableRoute
  '/financial/accounts-receivable': typeof AuthFinancialAccountsReceivableRoute
  '/financial/big-numbers': typeof AuthFinancialBigNumbersRoute
  '/financial/client-detail': typeof AuthFinancialClientDetailRoute
  '/financial/client-detail-interactive': typeof AuthFinancialClientDetailInteractiveRoute
  '/financial/client-matrix-interactive': typeof AuthFinancialClientMatrixInteractiveRoute
  '/financial/client-matrix-mock': typeof AuthFinancialClientMatrixMockRoute
  '/financial/dashboard': typeof AuthFinancialDashboardRoute
  '/financial/performance-clientes': typeof AuthFinancialPerformanceClientesRoute
  '/financial/proa': typeof AuthFinancialProaRoute
  '/groups/$groupId': typeof AuthGroupsGroupIdRoute
  '/meetings/schedule': typeof AuthMeetingsScheduleRoute
  '/notifications/preferences': typeof AuthNotificationsPreferencesRoute
  '/onboarding/$id': typeof AuthOnboardingIdRoute
  '/performance/clima': typeof AuthPerformanceClimaRoute
  '/performance/guia': typeof AuthPerformanceGuiaRoute
  '/performance/individual': typeof AuthPerformanceIndividualRoute
  '/performance/new': typeof AuthPerformanceNewRoute
  '/performance/okrs': typeof AuthPerformanceOkrsRoute
  '/recruitment/new': typeof AuthRecruitmentNewRoute
  '/revfinops/payables': typeof AuthRevfinopsPayablesRoute
  '/training/new': typeof AuthTrainingNewRoute
  '/users/$id': typeof AuthUsersIdRouteWithChildren
  '/vacation/approvals': typeof AuthVacationApprovalsRoute
  '/vacation/calendar': typeof AuthVacationCalendarRoute
  '/vacation/overview': typeof AuthVacationOverviewRoute
  '/vacation/request': typeof AuthVacationRequestRoute
  '/vacation/requests': typeof AuthVacationRequestsRoute
  '/workforce/audit-logs': typeof AuthWorkforceAuditLogsRoute
  '/workforce/payroll': typeof AuthWorkforcePayrollRoute
  '/s/$token': typeof PublicSTokenRoute
  '/clients': typeof AuthClientsIndexRoute
  '/documents': typeof AuthDocumentsIndexRoute
  '/financial': typeof AuthFinancialIndexRoute
  '/onboarding': typeof AuthOnboardingIndexRoute
  '/performance': typeof AuthPerformanceIndexRoute
  '/recruitment': typeof AuthRecruitmentIndexRoute
  '/revfinops': typeof AuthRevfinopsIndexRoute
  '/training': typeof AuthTrainingIndexRoute
  '/vacation': typeof AuthVacationIndexRoute
  '/clients/$clientCode/dashboard': typeof AuthClientsClientCodeDashboardRoute
  '/documents/$id/audit': typeof AuthDocumentsIdAuditRoute
  '/financial/bu-matrix/$buId': typeof AuthFinancialBuMatrixBuIdRoute
  '/financial/client-matrix/$clientId': typeof AuthFinancialClientMatrixClientIdRoute
  '/performance/avaliacoes/form': typeof AuthPerformanceAvaliacoesFormRoute
  '/performance/configuracoes/matriz': typeof AuthPerformanceConfiguracoesMatrizRoute
  '/performance/configuracoes/parametros': typeof AuthPerformanceConfiguracoesParametrosRoute
  '/performance/feedbacks/complete': typeof AuthPerformanceFeedbacksCompleteRoute
  '/performance/feedbacks/quick': typeof AuthPerformanceFeedbacksQuickRoute
  '/performance/feedbacks/received': typeof AuthPerformanceFeedbacksReceivedRoute
  '/revfinops/clients/new': typeof AuthRevfinopsClientsNewRoute
  '/templates/$id/use': typeof AuthTemplatesIdUseRoute
  '/users/$id/edit': typeof AuthUsersIdEditRoute
  '/workforce/departments/new': typeof AuthWorkforceDepartmentsNewRoute
  '/workforce/employees/new': typeof AuthWorkforceEmployeesNewRoute
  '/workforce/roles/new': typeof AuthWorkforceRolesNewRoute
  '/financial/bu-matrix': typeof AuthFinancialBuMatrixIndexRoute
  '/financial/client-matrix': typeof AuthFinancialClientMatrixIndexRoute
  '/financial/dre': typeof AuthFinancialDreIndexRoute
  '/performance/avaliacoes': typeof AuthPerformanceAvaliacoesIndexRoute
  '/performance/configuracoes': typeof AuthPerformanceConfiguracoesIndexRoute
  '/performance/feedbacks': typeof AuthPerformanceFeedbacksIndexRoute
  '/revfinops/clients': typeof AuthRevfinopsClientsIndexRoute
  '/sig/clients': typeof AuthSigClientsIndexRoute
  '/workforce/departments': typeof AuthWorkforceDepartmentsIndexRoute
  '/workforce/employees': typeof AuthWorkforceEmployeesIndexRoute
  '/workforce/roles': typeof AuthWorkforceRolesIndexRoute
  '/financial/dre/drilldown/$lineItem': typeof AuthFinancialDreDrilldownLineItemRoute
  '/workforce/departments/$departmentId/edit': typeof AuthWorkforceDepartmentsDepartmentIdEditRoute
  '/workforce/employees/$employeeId/edit': typeof AuthWorkforceEmployeesEmployeeIdEditRoute
  '/workforce/roles/$roleId/edit': typeof AuthWorkforceRolesRoleIdEditRoute
  '/workforce/departments/$departmentId': typeof AuthWorkforceDepartmentsDepartmentIdIndexRoute
  '/workforce/employees/$employeeId': typeof AuthWorkforceEmployeesEmployeeIdIndexRoute
  '/workforce/roles/$roleId': typeof AuthWorkforceRolesRoleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_unauth': typeof UnauthRouteWithChildren
  '/error': typeof ErrorRoute
  '/_auth/available-budget': typeof AuthAvailableBudgetRoute
  '/_auth/calendar': typeof AuthCalendarRoute
  '/_auth/component-showcase': typeof AuthComponentShowcaseRoute
  '/_auth/config': typeof AuthConfigRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/employees': typeof AuthEmployeesRoute
  '/_auth/financial': typeof AuthFinancialRouteWithChildren
  '/_auth/janes': typeof AuthJanesRoute
  '/_auth/metas-gestao': typeof AuthMetasGestaoRoute
  '/_auth/my-business-targets': typeof AuthMyBusinessTargetsRoute
  '/_auth/my-courses': typeof AuthMyCoursesRoute
  '/_auth/my-evaluation': typeof AuthMyEvaluationRoute
  '/_auth/my-onboarding': typeof AuthMyOnboardingRoute
  '/_auth/my-team': typeof AuthMyTeamRoute
  '/_auth/orgchart': typeof AuthOrgchartRoute
  '/_auth/people': typeof AuthPeopleRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_auth/projections': typeof AuthProjectionsRoute
  '/_auth/reports': typeof AuthReportsRoute
  '/_auth/results': typeof AuthResultsRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/sig': typeof AuthSigRouteWithChildren
  '/_auth/sign-documents': typeof AuthSignDocumentsRoute
  '/_auth/team-courses': typeof AuthTeamCoursesRoute
  '/_auth/team-evaluation': typeof AuthTeamEvaluationRoute
  '/_auth/theme-preview': typeof AuthThemePreviewRoute
  '/_unauth/login': typeof UnauthLoginRoute
  '/_unauth/register': typeof UnauthRegisterRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/design-system/analytics-dashboard': typeof AuthDesignSystemAnalyticsDashboardRoute
  '/_auth/design-system/analytics-showcase': typeof AuthDesignSystemAnalyticsShowcaseRoute
  '/_auth/documents/$id': typeof AuthDocumentsIdRouteWithChildren
  '/_auth/financial/accounts-payable': typeof AuthFinancialAccountsPayableRoute
  '/_auth/financial/accounts-receivable': typeof AuthFinancialAccountsReceivableRoute
  '/_auth/financial/big-numbers': typeof AuthFinancialBigNumbersRoute
  '/_auth/financial/client-detail': typeof AuthFinancialClientDetailRoute
  '/_auth/financial/client-detail-interactive': typeof AuthFinancialClientDetailInteractiveRoute
  '/_auth/financial/client-matrix-interactive': typeof AuthFinancialClientMatrixInteractiveRoute
  '/_auth/financial/client-matrix-mock': typeof AuthFinancialClientMatrixMockRoute
  '/_auth/financial/dashboard': typeof AuthFinancialDashboardRoute
  '/_auth/financial/performance-clientes': typeof AuthFinancialPerformanceClientesRoute
  '/_auth/financial/proa': typeof AuthFinancialProaRoute
  '/_auth/groups/$groupId': typeof AuthGroupsGroupIdRoute
  '/_auth/meetings/schedule': typeof AuthMeetingsScheduleRoute
  '/_auth/notifications/preferences': typeof AuthNotificationsPreferencesRoute
  '/_auth/onboarding/$id': typeof AuthOnboardingIdRoute
  '/_auth/performance/clima': typeof AuthPerformanceClimaRoute
  '/_auth/performance/guia': typeof AuthPerformanceGuiaRoute
  '/_auth/performance/individual': typeof AuthPerformanceIndividualRoute
  '/_auth/performance/new': typeof AuthPerformanceNewRoute
  '/_auth/performance/okrs': typeof AuthPerformanceOkrsRoute
  '/_auth/recruitment/new': typeof AuthRecruitmentNewRoute
  '/_auth/revfinops/payables': typeof AuthRevfinopsPayablesRoute
  '/_auth/training/new': typeof AuthTrainingNewRoute
  '/_auth/users/$id': typeof AuthUsersIdRouteWithChildren
  '/_auth/vacation/approvals': typeof AuthVacationApprovalsRoute
  '/_auth/vacation/calendar': typeof AuthVacationCalendarRoute
  '/_auth/vacation/overview': typeof AuthVacationOverviewRoute
  '/_auth/vacation/request': typeof AuthVacationRequestRoute
  '/_auth/vacation/requests': typeof AuthVacationRequestsRoute
  '/_auth/workforce/audit-logs': typeof AuthWorkforceAuditLogsRoute
  '/_auth/workforce/payroll': typeof AuthWorkforcePayrollRoute
  '/_public/s/$token': typeof PublicSTokenRoute
  '/_auth/clients/': typeof AuthClientsIndexRoute
  '/_auth/documents/': typeof AuthDocumentsIndexRoute
  '/_auth/financial/': typeof AuthFinancialIndexRoute
  '/_auth/onboarding/': typeof AuthOnboardingIndexRoute
  '/_auth/performance/': typeof AuthPerformanceIndexRoute
  '/_auth/recruitment/': typeof AuthRecruitmentIndexRoute
  '/_auth/revfinops/': typeof AuthRevfinopsIndexRoute
  '/_auth/training/': typeof AuthTrainingIndexRoute
  '/_auth/vacation/': typeof AuthVacationIndexRoute
  '/_auth/clients/$clientCode/dashboard': typeof AuthClientsClientCodeDashboardRoute
  '/_auth/documents/$id/audit': typeof AuthDocumentsIdAuditRoute
  '/_auth/financial/bu-matrix/$buId': typeof AuthFinancialBuMatrixBuIdRoute
  '/_auth/financial/client-matrix/$clientId': typeof AuthFinancialClientMatrixClientIdRoute
  '/_auth/performance/avaliacoes/form': typeof AuthPerformanceAvaliacoesFormRoute
  '/_auth/performance/configuracoes/matriz': typeof AuthPerformanceConfiguracoesMatrizRoute
  '/_auth/performance/configuracoes/parametros': typeof AuthPerformanceConfiguracoesParametrosRoute
  '/_auth/performance/feedbacks/complete': typeof AuthPerformanceFeedbacksCompleteRoute
  '/_auth/performance/feedbacks/quick': typeof AuthPerformanceFeedbacksQuickRoute
  '/_auth/performance/feedbacks/received': typeof AuthPerformanceFeedbacksReceivedRoute
  '/_auth/revfinops/clients/new': typeof AuthRevfinopsClientsNewRoute
  '/_auth/templates/$id/use': typeof AuthTemplatesIdUseRoute
  '/_auth/users/$id/edit': typeof AuthUsersIdEditRoute
  '/_auth/workforce/departments/new': typeof AuthWorkforceDepartmentsNewRoute
  '/_auth/workforce/employees/new': typeof AuthWorkforceEmployeesNewRoute
  '/_auth/workforce/roles/new': typeof AuthWorkforceRolesNewRoute
  '/_auth/financial/bu-matrix/': typeof AuthFinancialBuMatrixIndexRoute
  '/_auth/financial/client-matrix/': typeof AuthFinancialClientMatrixIndexRoute
  '/_auth/financial/dre/': typeof AuthFinancialDreIndexRoute
  '/_auth/performance/avaliacoes/': typeof AuthPerformanceAvaliacoesIndexRoute
  '/_auth/performance/configuracoes/': typeof AuthPerformanceConfiguracoesIndexRoute
  '/_auth/performance/feedbacks/': typeof AuthPerformanceFeedbacksIndexRoute
  '/_auth/revfinops/clients/': typeof AuthRevfinopsClientsIndexRoute
  '/_auth/sig/clients/': typeof AuthSigClientsIndexRoute
  '/_auth/workforce/departments/': typeof AuthWorkforceDepartmentsIndexRoute
  '/_auth/workforce/employees/': typeof AuthWorkforceEmployeesIndexRoute
  '/_auth/workforce/roles/': typeof AuthWorkforceRolesIndexRoute
  '/_auth/financial/dre/drilldown/$lineItem': typeof AuthFinancialDreDrilldownLineItemRoute
  '/_auth/workforce/departments/$departmentId/edit': typeof AuthWorkforceDepartmentsDepartmentIdEditRoute
  '/_auth/workforce/employees/$employeeId/edit': typeof AuthWorkforceEmployeesEmployeeIdEditRoute
  '/_auth/workforce/roles/$roleId/edit': typeof AuthWorkforceRolesRoleIdEditRoute
  '/_auth/workforce/departments/$departmentId/': typeof AuthWorkforceDepartmentsDepartmentIdIndexRoute
  '/_auth/workforce/employees/$employeeId/': typeof AuthWorkforceEmployeesEmployeeIdIndexRoute
  '/_auth/workforce/roles/$roleId/': typeof AuthWorkforceRolesRoleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/error'
    | '/available-budget'
    | '/calendar'
    | '/component-showcase'
    | '/config'
    | '/dashboard'
    | '/employees'
    | '/financial'
    | '/janes'
    | '/metas-gestao'
    | '/my-business-targets'
    | '/my-courses'
    | '/my-evaluation'
    | '/my-onboarding'
    | '/my-team'
    | '/orgchart'
    | '/people'
    | '/profile'
    | '/projections'
    | '/reports'
    | '/results'
    | '/settings'
    | '/sig'
    | '/sign-documents'
    | '/team-courses'
    | '/team-evaluation'
    | '/theme-preview'
    | '/login'
    | '/register'
    | '/'
    | '/design-system/analytics-dashboard'
    | '/design-system/analytics-showcase'
    | '/documents/$id'
    | '/financial/accounts-payable'
    | '/financial/accounts-receivable'
    | '/financial/big-numbers'
    | '/financial/client-detail'
    | '/financial/client-detail-interactive'
    | '/financial/client-matrix-interactive'
    | '/financial/client-matrix-mock'
    | '/financial/dashboard'
    | '/financial/performance-clientes'
    | '/financial/proa'
    | '/groups/$groupId'
    | '/meetings/schedule'
    | '/notifications/preferences'
    | '/onboarding/$id'
    | '/performance/clima'
    | '/performance/guia'
    | '/performance/individual'
    | '/performance/new'
    | '/performance/okrs'
    | '/recruitment/new'
    | '/revfinops/payables'
    | '/training/new'
    | '/users/$id'
    | '/vacation/approvals'
    | '/vacation/calendar'
    | '/vacation/overview'
    | '/vacation/request'
    | '/vacation/requests'
    | '/workforce/audit-logs'
    | '/workforce/payroll'
    | '/s/$token'
    | '/clients'
    | '/documents'
    | '/financial/'
    | '/onboarding'
    | '/performance'
    | '/recruitment'
    | '/revfinops'
    | '/training'
    | '/vacation'
    | '/clients/$clientCode/dashboard'
    | '/documents/$id/audit'
    | '/financial/bu-matrix/$buId'
    | '/financial/client-matrix/$clientId'
    | '/performance/avaliacoes/form'
    | '/performance/configuracoes/matriz'
    | '/performance/configuracoes/parametros'
    | '/performance/feedbacks/complete'
    | '/performance/feedbacks/quick'
    | '/performance/feedbacks/received'
    | '/revfinops/clients/new'
    | '/templates/$id/use'
    | '/users/$id/edit'
    | '/workforce/departments/new'
    | '/workforce/employees/new'
    | '/workforce/roles/new'
    | '/financial/bu-matrix'
    | '/financial/client-matrix'
    | '/financial/dre'
    | '/performance/avaliacoes'
    | '/performance/configuracoes'
    | '/performance/feedbacks'
    | '/revfinops/clients'
    | '/sig/clients'
    | '/workforce/departments'
    | '/workforce/employees'
    | '/workforce/roles'
    | '/financial/dre/drilldown/$lineItem'
    | '/workforce/departments/$departmentId/edit'
    | '/workforce/employees/$employeeId/edit'
    | '/workforce/roles/$roleId/edit'
    | '/workforce/departments/$departmentId'
    | '/workforce/employees/$employeeId'
    | '/workforce/roles/$roleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/error'
    | '/available-budget'
    | '/calendar'
    | '/component-showcase'
    | '/config'
    | '/dashboard'
    | '/employees'
    | '/janes'
    | '/metas-gestao'
    | '/my-business-targets'
    | '/my-courses'
    | '/my-evaluation'
    | '/my-onboarding'
    | '/my-team'
    | '/orgchart'
    | '/people'
    | '/profile'
    | '/projections'
    | '/reports'
    | '/results'
    | '/settings'
    | '/sig'
    | '/sign-documents'
    | '/team-courses'
    | '/team-evaluation'
    | '/theme-preview'
    | '/login'
    | '/register'
    | '/'
    | '/design-system/analytics-dashboard'
    | '/design-system/analytics-showcase'
    | '/documents/$id'
    | '/financial/accounts-payable'
    | '/financial/accounts-receivable'
    | '/financial/big-numbers'
    | '/financial/client-detail'
    | '/financial/client-detail-interactive'
    | '/financial/client-matrix-interactive'
    | '/financial/client-matrix-mock'
    | '/financial/dashboard'
    | '/financial/performance-clientes'
    | '/financial/proa'
    | '/groups/$groupId'
    | '/meetings/schedule'
    | '/notifications/preferences'
    | '/onboarding/$id'
    | '/performance/clima'
    | '/performance/guia'
    | '/performance/individual'
    | '/performance/new'
    | '/performance/okrs'
    | '/recruitment/new'
    | '/revfinops/payables'
    | '/training/new'
    | '/users/$id'
    | '/vacation/approvals'
    | '/vacation/calendar'
    | '/vacation/overview'
    | '/vacation/request'
    | '/vacation/requests'
    | '/workforce/audit-logs'
    | '/workforce/payroll'
    | '/s/$token'
    | '/clients'
    | '/documents'
    | '/financial'
    | '/onboarding'
    | '/performance'
    | '/recruitment'
    | '/revfinops'
    | '/training'
    | '/vacation'
    | '/clients/$clientCode/dashboard'
    | '/documents/$id/audit'
    | '/financial/bu-matrix/$buId'
    | '/financial/client-matrix/$clientId'
    | '/performance/avaliacoes/form'
    | '/performance/configuracoes/matriz'
    | '/performance/configuracoes/parametros'
    | '/performance/feedbacks/complete'
    | '/performance/feedbacks/quick'
    | '/performance/feedbacks/received'
    | '/revfinops/clients/new'
    | '/templates/$id/use'
    | '/users/$id/edit'
    | '/workforce/departments/new'
    | '/workforce/employees/new'
    | '/workforce/roles/new'
    | '/financial/bu-matrix'
    | '/financial/client-matrix'
    | '/financial/dre'
    | '/performance/avaliacoes'
    | '/performance/configuracoes'
    | '/performance/feedbacks'
    | '/revfinops/clients'
    | '/sig/clients'
    | '/workforce/departments'
    | '/workforce/employees'
    | '/workforce/roles'
    | '/financial/dre/drilldown/$lineItem'
    | '/workforce/departments/$departmentId/edit'
    | '/workforce/employees/$employeeId/edit'
    | '/workforce/roles/$roleId/edit'
    | '/workforce/departments/$departmentId'
    | '/workforce/employees/$employeeId'
    | '/workforce/roles/$roleId'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_unauth'
    | '/error'
    | '/_auth/available-budget'
    | '/_auth/calendar'
    | '/_auth/component-showcase'
    | '/_auth/config'
    | '/_auth/dashboard'
    | '/_auth/employees'
    | '/_auth/financial'
    | '/_auth/janes'
    | '/_auth/metas-gestao'
    | '/_auth/my-business-targets'
    | '/_auth/my-courses'
    | '/_auth/my-evaluation'
    | '/_auth/my-onboarding'
    | '/_auth/my-team'
    | '/_auth/orgchart'
    | '/_auth/people'
    | '/_auth/profile'
    | '/_auth/projections'
    | '/_auth/reports'
    | '/_auth/results'
    | '/_auth/settings'
    | '/_auth/sig'
    | '/_auth/sign-documents'
    | '/_auth/team-courses'
    | '/_auth/team-evaluation'
    | '/_auth/theme-preview'
    | '/_unauth/login'
    | '/_unauth/register'
    | '/_auth/'
    | '/_auth/design-system/analytics-dashboard'
    | '/_auth/design-system/analytics-showcase'
    | '/_auth/documents/$id'
    | '/_auth/financial/accounts-payable'
    | '/_auth/financial/accounts-receivable'
    | '/_auth/financial/big-numbers'
    | '/_auth/financial/client-detail'
    | '/_auth/financial/client-detail-interactive'
    | '/_auth/financial/client-matrix-interactive'
    | '/_auth/financial/client-matrix-mock'
    | '/_auth/financial/dashboard'
    | '/_auth/financial/performance-clientes'
    | '/_auth/financial/proa'
    | '/_auth/groups/$groupId'
    | '/_auth/meetings/schedule'
    | '/_auth/notifications/preferences'
    | '/_auth/onboarding/$id'
    | '/_auth/performance/clima'
    | '/_auth/performance/guia'
    | '/_auth/performance/individual'
    | '/_auth/performance/new'
    | '/_auth/performance/okrs'
    | '/_auth/recruitment/new'
    | '/_auth/revfinops/payables'
    | '/_auth/training/new'
    | '/_auth/users/$id'
    | '/_auth/vacation/approvals'
    | '/_auth/vacation/calendar'
    | '/_auth/vacation/overview'
    | '/_auth/vacation/request'
    | '/_auth/vacation/requests'
    | '/_auth/workforce/audit-logs'
    | '/_auth/workforce/payroll'
    | '/_public/s/$token'
    | '/_auth/clients/'
    | '/_auth/documents/'
    | '/_auth/financial/'
    | '/_auth/onboarding/'
    | '/_auth/performance/'
    | '/_auth/recruitment/'
    | '/_auth/revfinops/'
    | '/_auth/training/'
    | '/_auth/vacation/'
    | '/_auth/clients/$clientCode/dashboard'
    | '/_auth/documents/$id/audit'
    | '/_auth/financial/bu-matrix/$buId'
    | '/_auth/financial/client-matrix/$clientId'
    | '/_auth/performance/avaliacoes/form'
    | '/_auth/performance/configuracoes/matriz'
    | '/_auth/performance/configuracoes/parametros'
    | '/_auth/performance/feedbacks/complete'
    | '/_auth/performance/feedbacks/quick'
    | '/_auth/performance/feedbacks/received'
    | '/_auth/revfinops/clients/new'
    | '/_auth/templates/$id/use'
    | '/_auth/users/$id/edit'
    | '/_auth/workforce/departments/new'
    | '/_auth/workforce/employees/new'
    | '/_auth/workforce/roles/new'
    | '/_auth/financial/bu-matrix/'
    | '/_auth/financial/client-matrix/'
    | '/_auth/financial/dre/'
    | '/_auth/performance/avaliacoes/'
    | '/_auth/performance/configuracoes/'
    | '/_auth/performance/feedbacks/'
    | '/_auth/revfinops/clients/'
    | '/_auth/sig/clients/'
    | '/_auth/workforce/departments/'
    | '/_auth/workforce/employees/'
    | '/_auth/workforce/roles/'
    | '/_auth/financial/dre/drilldown/$lineItem'
    | '/_auth/workforce/departments/$departmentId/edit'
    | '/_auth/workforce/employees/$employeeId/edit'
    | '/_auth/workforce/roles/$roleId/edit'
    | '/_auth/workforce/departments/$departmentId/'
    | '/_auth/workforce/employees/$employeeId/'
    | '/_auth/workforce/roles/$roleId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  UnauthRoute: typeof UnauthRouteWithChildren
  ErrorRoute: typeof ErrorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauth': {
      id: '/_unauth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_unauth/register': {
      id: '/_unauth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof UnauthRegisterRouteImport
      parentRoute: typeof UnauthRoute
    }
    '/_unauth/login': {
      id: '/_unauth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthLoginRouteImport
      parentRoute: typeof UnauthRoute
    }
    '/_auth/theme-preview': {
      id: '/_auth/theme-preview'
      path: '/theme-preview'
      fullPath: '/theme-preview'
      preLoaderRoute: typeof AuthThemePreviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/team-evaluation': {
      id: '/_auth/team-evaluation'
      path: '/team-evaluation'
      fullPath: '/team-evaluation'
      preLoaderRoute: typeof AuthTeamEvaluationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/team-courses': {
      id: '/_auth/team-courses'
      path: '/team-courses'
      fullPath: '/team-courses'
      preLoaderRoute: typeof AuthTeamCoursesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-documents': {
      id: '/_auth/sign-documents'
      path: '/sign-documents'
      fullPath: '/sign-documents'
      preLoaderRoute: typeof AuthSignDocumentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sig': {
      id: '/_auth/sig'
      path: '/sig'
      fullPath: '/sig'
      preLoaderRoute: typeof AuthSigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/results': {
      id: '/_auth/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof AuthResultsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projections': {
      id: '/_auth/projections'
      path: '/projections'
      fullPath: '/projections'
      preLoaderRoute: typeof AuthProjectionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/people': {
      id: '/_auth/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AuthPeopleRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orgchart': {
      id: '/_auth/orgchart'
      path: '/orgchart'
      fullPath: '/orgchart'
      preLoaderRoute: typeof AuthOrgchartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-team': {
      id: '/_auth/my-team'
      path: '/my-team'
      fullPath: '/my-team'
      preLoaderRoute: typeof AuthMyTeamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-onboarding': {
      id: '/_auth/my-onboarding'
      path: '/my-onboarding'
      fullPath: '/my-onboarding'
      preLoaderRoute: typeof AuthMyOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-evaluation': {
      id: '/_auth/my-evaluation'
      path: '/my-evaluation'
      fullPath: '/my-evaluation'
      preLoaderRoute: typeof AuthMyEvaluationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-courses': {
      id: '/_auth/my-courses'
      path: '/my-courses'
      fullPath: '/my-courses'
      preLoaderRoute: typeof AuthMyCoursesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-business-targets': {
      id: '/_auth/my-business-targets'
      path: '/my-business-targets'
      fullPath: '/my-business-targets'
      preLoaderRoute: typeof AuthMyBusinessTargetsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/metas-gestao': {
      id: '/_auth/metas-gestao'
      path: '/metas-gestao'
      fullPath: '/metas-gestao'
      preLoaderRoute: typeof AuthMetasGestaoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/janes': {
      id: '/_auth/janes'
      path: '/janes'
      fullPath: '/janes'
      preLoaderRoute: typeof AuthJanesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial': {
      id: '/_auth/financial'
      path: '/financial'
      fullPath: '/financial'
      preLoaderRoute: typeof AuthFinancialRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/employees': {
      id: '/_auth/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/config': {
      id: '/_auth/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof AuthConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/component-showcase': {
      id: '/_auth/component-showcase'
      path: '/component-showcase'
      fullPath: '/component-showcase'
      preLoaderRoute: typeof AuthComponentShowcaseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calendar': {
      id: '/_auth/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/available-budget': {
      id: '/_auth/available-budget'
      path: '/available-budget'
      fullPath: '/available-budget'
      preLoaderRoute: typeof AuthAvailableBudgetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/': {
      id: '/_auth/vacation/'
      path: '/vacation'
      fullPath: '/vacation'
      preLoaderRoute: typeof AuthVacationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/training/': {
      id: '/_auth/training/'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthTrainingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/revfinops/': {
      id: '/_auth/revfinops/'
      path: '/revfinops'
      fullPath: '/revfinops'
      preLoaderRoute: typeof AuthRevfinopsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recruitment/': {
      id: '/_auth/recruitment/'
      path: '/recruitment'
      fullPath: '/recruitment'
      preLoaderRoute: typeof AuthRecruitmentIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/': {
      id: '/_auth/performance/'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthPerformanceIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding/': {
      id: '/_auth/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial/': {
      id: '/_auth/financial/'
      path: '/'
      fullPath: '/financial/'
      preLoaderRoute: typeof AuthFinancialIndexRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthDocumentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/': {
      id: '/_auth/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthClientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/s/$token': {
      id: '/_public/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof PublicSTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/workforce/payroll': {
      id: '/_auth/workforce/payroll'
      path: '/workforce/payroll'
      fullPath: '/workforce/payroll'
      preLoaderRoute: typeof AuthWorkforcePayrollRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/audit-logs': {
      id: '/_auth/workforce/audit-logs'
      path: '/workforce/audit-logs'
      fullPath: '/workforce/audit-logs'
      preLoaderRoute: typeof AuthWorkforceAuditLogsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/requests': {
      id: '/_auth/vacation/requests'
      path: '/vacation/requests'
      fullPath: '/vacation/requests'
      preLoaderRoute: typeof AuthVacationRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/request': {
      id: '/_auth/vacation/request'
      path: '/vacation/request'
      fullPath: '/vacation/request'
      preLoaderRoute: typeof AuthVacationRequestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/overview': {
      id: '/_auth/vacation/overview'
      path: '/vacation/overview'
      fullPath: '/vacation/overview'
      preLoaderRoute: typeof AuthVacationOverviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/calendar': {
      id: '/_auth/vacation/calendar'
      path: '/vacation/calendar'
      fullPath: '/vacation/calendar'
      preLoaderRoute: typeof AuthVacationCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vacation/approvals': {
      id: '/_auth/vacation/approvals'
      path: '/vacation/approvals'
      fullPath: '/vacation/approvals'
      preLoaderRoute: typeof AuthVacationApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/$id': {
      id: '/_auth/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthUsersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/training/new': {
      id: '/_auth/training/new'
      path: '/training/new'
      fullPath: '/training/new'
      preLoaderRoute: typeof AuthTrainingNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/revfinops/payables': {
      id: '/_auth/revfinops/payables'
      path: '/revfinops/payables'
      fullPath: '/revfinops/payables'
      preLoaderRoute: typeof AuthRevfinopsPayablesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recruitment/new': {
      id: '/_auth/recruitment/new'
      path: '/recruitment/new'
      fullPath: '/recruitment/new'
      preLoaderRoute: typeof AuthRecruitmentNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/okrs': {
      id: '/_auth/performance/okrs'
      path: '/performance/okrs'
      fullPath: '/performance/okrs'
      preLoaderRoute: typeof AuthPerformanceOkrsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/new': {
      id: '/_auth/performance/new'
      path: '/performance/new'
      fullPath: '/performance/new'
      preLoaderRoute: typeof AuthPerformanceNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/individual': {
      id: '/_auth/performance/individual'
      path: '/performance/individual'
      fullPath: '/performance/individual'
      preLoaderRoute: typeof AuthPerformanceIndividualRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/guia': {
      id: '/_auth/performance/guia'
      path: '/performance/guia'
      fullPath: '/performance/guia'
      preLoaderRoute: typeof AuthPerformanceGuiaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/clima': {
      id: '/_auth/performance/clima'
      path: '/performance/clima'
      fullPath: '/performance/clima'
      preLoaderRoute: typeof AuthPerformanceClimaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding/$id': {
      id: '/_auth/onboarding/$id'
      path: '/onboarding/$id'
      fullPath: '/onboarding/$id'
      preLoaderRoute: typeof AuthOnboardingIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/notifications/preferences': {
      id: '/_auth/notifications/preferences'
      path: '/notifications/preferences'
      fullPath: '/notifications/preferences'
      preLoaderRoute: typeof AuthNotificationsPreferencesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings/schedule': {
      id: '/_auth/meetings/schedule'
      path: '/meetings/schedule'
      fullPath: '/meetings/schedule'
      preLoaderRoute: typeof AuthMeetingsScheduleRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/groups/$groupId': {
      id: '/_auth/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AuthGroupsGroupIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial/proa': {
      id: '/_auth/financial/proa'
      path: '/proa'
      fullPath: '/financial/proa'
      preLoaderRoute: typeof AuthFinancialProaRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/performance-clientes': {
      id: '/_auth/financial/performance-clientes'
      path: '/performance-clientes'
      fullPath: '/financial/performance-clientes'
      preLoaderRoute: typeof AuthFinancialPerformanceClientesRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/dashboard': {
      id: '/_auth/financial/dashboard'
      path: '/dashboard'
      fullPath: '/financial/dashboard'
      preLoaderRoute: typeof AuthFinancialDashboardRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/client-matrix-mock': {
      id: '/_auth/financial/client-matrix-mock'
      path: '/client-matrix-mock'
      fullPath: '/financial/client-matrix-mock'
      preLoaderRoute: typeof AuthFinancialClientMatrixMockRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/client-matrix-interactive': {
      id: '/_auth/financial/client-matrix-interactive'
      path: '/client-matrix-interactive'
      fullPath: '/financial/client-matrix-interactive'
      preLoaderRoute: typeof AuthFinancialClientMatrixInteractiveRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/client-detail-interactive': {
      id: '/_auth/financial/client-detail-interactive'
      path: '/client-detail-interactive'
      fullPath: '/financial/client-detail-interactive'
      preLoaderRoute: typeof AuthFinancialClientDetailInteractiveRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/client-detail': {
      id: '/_auth/financial/client-detail'
      path: '/client-detail'
      fullPath: '/financial/client-detail'
      preLoaderRoute: typeof AuthFinancialClientDetailRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/big-numbers': {
      id: '/_auth/financial/big-numbers'
      path: '/big-numbers'
      fullPath: '/financial/big-numbers'
      preLoaderRoute: typeof AuthFinancialBigNumbersRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/accounts-receivable': {
      id: '/_auth/financial/accounts-receivable'
      path: '/accounts-receivable'
      fullPath: '/financial/accounts-receivable'
      preLoaderRoute: typeof AuthFinancialAccountsReceivableRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/accounts-payable': {
      id: '/_auth/financial/accounts-payable'
      path: '/accounts-payable'
      fullPath: '/financial/accounts-payable'
      preLoaderRoute: typeof AuthFinancialAccountsPayableRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/documents/$id': {
      id: '/_auth/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AuthDocumentsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/design-system/analytics-showcase': {
      id: '/_auth/design-system/analytics-showcase'
      path: '/design-system/analytics-showcase'
      fullPath: '/design-system/analytics-showcase'
      preLoaderRoute: typeof AuthDesignSystemAnalyticsShowcaseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/design-system/analytics-dashboard': {
      id: '/_auth/design-system/analytics-dashboard'
      path: '/design-system/analytics-dashboard'
      fullPath: '/design-system/analytics-dashboard'
      preLoaderRoute: typeof AuthDesignSystemAnalyticsDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/roles/': {
      id: '/_auth/workforce/roles/'
      path: '/workforce/roles'
      fullPath: '/workforce/roles'
      preLoaderRoute: typeof AuthWorkforceRolesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/employees/': {
      id: '/_auth/workforce/employees/'
      path: '/workforce/employees'
      fullPath: '/workforce/employees'
      preLoaderRoute: typeof AuthWorkforceEmployeesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/departments/': {
      id: '/_auth/workforce/departments/'
      path: '/workforce/departments'
      fullPath: '/workforce/departments'
      preLoaderRoute: typeof AuthWorkforceDepartmentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sig/clients/': {
      id: '/_auth/sig/clients/'
      path: '/clients'
      fullPath: '/sig/clients'
      preLoaderRoute: typeof AuthSigClientsIndexRouteImport
      parentRoute: typeof AuthSigRoute
    }
    '/_auth/revfinops/clients/': {
      id: '/_auth/revfinops/clients/'
      path: '/revfinops/clients'
      fullPath: '/revfinops/clients'
      preLoaderRoute: typeof AuthRevfinopsClientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/feedbacks/': {
      id: '/_auth/performance/feedbacks/'
      path: '/performance/feedbacks'
      fullPath: '/performance/feedbacks'
      preLoaderRoute: typeof AuthPerformanceFeedbacksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/configuracoes/': {
      id: '/_auth/performance/configuracoes/'
      path: '/performance/configuracoes'
      fullPath: '/performance/configuracoes'
      preLoaderRoute: typeof AuthPerformanceConfiguracoesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/avaliacoes/': {
      id: '/_auth/performance/avaliacoes/'
      path: '/performance/avaliacoes'
      fullPath: '/performance/avaliacoes'
      preLoaderRoute: typeof AuthPerformanceAvaliacoesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial/dre/': {
      id: '/_auth/financial/dre/'
      path: '/dre'
      fullPath: '/financial/dre'
      preLoaderRoute: typeof AuthFinancialDreIndexRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/client-matrix/': {
      id: '/_auth/financial/client-matrix/'
      path: '/client-matrix'
      fullPath: '/financial/client-matrix'
      preLoaderRoute: typeof AuthFinancialClientMatrixIndexRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/bu-matrix/': {
      id: '/_auth/financial/bu-matrix/'
      path: '/bu-matrix'
      fullPath: '/financial/bu-matrix'
      preLoaderRoute: typeof AuthFinancialBuMatrixIndexRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/workforce/roles/new': {
      id: '/_auth/workforce/roles/new'
      path: '/workforce/roles/new'
      fullPath: '/workforce/roles/new'
      preLoaderRoute: typeof AuthWorkforceRolesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/employees/new': {
      id: '/_auth/workforce/employees/new'
      path: '/workforce/employees/new'
      fullPath: '/workforce/employees/new'
      preLoaderRoute: typeof AuthWorkforceEmployeesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/departments/new': {
      id: '/_auth/workforce/departments/new'
      path: '/workforce/departments/new'
      fullPath: '/workforce/departments/new'
      preLoaderRoute: typeof AuthWorkforceDepartmentsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/$id/edit': {
      id: '/_auth/users/$id/edit'
      path: '/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof AuthUsersIdEditRouteImport
      parentRoute: typeof AuthUsersIdRoute
    }
    '/_auth/templates/$id/use': {
      id: '/_auth/templates/$id/use'
      path: '/templates/$id/use'
      fullPath: '/templates/$id/use'
      preLoaderRoute: typeof AuthTemplatesIdUseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/revfinops/clients/new': {
      id: '/_auth/revfinops/clients/new'
      path: '/revfinops/clients/new'
      fullPath: '/revfinops/clients/new'
      preLoaderRoute: typeof AuthRevfinopsClientsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/feedbacks/received': {
      id: '/_auth/performance/feedbacks/received'
      path: '/performance/feedbacks/received'
      fullPath: '/performance/feedbacks/received'
      preLoaderRoute: typeof AuthPerformanceFeedbacksReceivedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/feedbacks/quick': {
      id: '/_auth/performance/feedbacks/quick'
      path: '/performance/feedbacks/quick'
      fullPath: '/performance/feedbacks/quick'
      preLoaderRoute: typeof AuthPerformanceFeedbacksQuickRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/feedbacks/complete': {
      id: '/_auth/performance/feedbacks/complete'
      path: '/performance/feedbacks/complete'
      fullPath: '/performance/feedbacks/complete'
      preLoaderRoute: typeof AuthPerformanceFeedbacksCompleteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/configuracoes/parametros': {
      id: '/_auth/performance/configuracoes/parametros'
      path: '/performance/configuracoes/parametros'
      fullPath: '/performance/configuracoes/parametros'
      preLoaderRoute: typeof AuthPerformanceConfiguracoesParametrosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/configuracoes/matriz': {
      id: '/_auth/performance/configuracoes/matriz'
      path: '/performance/configuracoes/matriz'
      fullPath: '/performance/configuracoes/matriz'
      preLoaderRoute: typeof AuthPerformanceConfiguracoesMatrizRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance/avaliacoes/form': {
      id: '/_auth/performance/avaliacoes/form'
      path: '/performance/avaliacoes/form'
      fullPath: '/performance/avaliacoes/form'
      preLoaderRoute: typeof AuthPerformanceAvaliacoesFormRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial/client-matrix/$clientId': {
      id: '/_auth/financial/client-matrix/$clientId'
      path: '/client-matrix/$clientId'
      fullPath: '/financial/client-matrix/$clientId'
      preLoaderRoute: typeof AuthFinancialClientMatrixClientIdRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/financial/bu-matrix/$buId': {
      id: '/_auth/financial/bu-matrix/$buId'
      path: '/bu-matrix/$buId'
      fullPath: '/financial/bu-matrix/$buId'
      preLoaderRoute: typeof AuthFinancialBuMatrixBuIdRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
    '/_auth/documents/$id/audit': {
      id: '/_auth/documents/$id/audit'
      path: '/audit'
      fullPath: '/documents/$id/audit'
      preLoaderRoute: typeof AuthDocumentsIdAuditRouteImport
      parentRoute: typeof AuthDocumentsIdRoute
    }
    '/_auth/clients/$clientCode/dashboard': {
      id: '/_auth/clients/$clientCode/dashboard'
      path: '/clients/$clientCode/dashboard'
      fullPath: '/clients/$clientCode/dashboard'
      preLoaderRoute: typeof AuthClientsClientCodeDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/roles/$roleId/': {
      id: '/_auth/workforce/roles/$roleId/'
      path: '/workforce/roles/$roleId'
      fullPath: '/workforce/roles/$roleId'
      preLoaderRoute: typeof AuthWorkforceRolesRoleIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/employees/$employeeId/': {
      id: '/_auth/workforce/employees/$employeeId/'
      path: '/workforce/employees/$employeeId'
      fullPath: '/workforce/employees/$employeeId'
      preLoaderRoute: typeof AuthWorkforceEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/departments/$departmentId/': {
      id: '/_auth/workforce/departments/$departmentId/'
      path: '/workforce/departments/$departmentId'
      fullPath: '/workforce/departments/$departmentId'
      preLoaderRoute: typeof AuthWorkforceDepartmentsDepartmentIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/roles/$roleId/edit': {
      id: '/_auth/workforce/roles/$roleId/edit'
      path: '/workforce/roles/$roleId/edit'
      fullPath: '/workforce/roles/$roleId/edit'
      preLoaderRoute: typeof AuthWorkforceRolesRoleIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/employees/$employeeId/edit': {
      id: '/_auth/workforce/employees/$employeeId/edit'
      path: '/workforce/employees/$employeeId/edit'
      fullPath: '/workforce/employees/$employeeId/edit'
      preLoaderRoute: typeof AuthWorkforceEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workforce/departments/$departmentId/edit': {
      id: '/_auth/workforce/departments/$departmentId/edit'
      path: '/workforce/departments/$departmentId/edit'
      fullPath: '/workforce/departments/$departmentId/edit'
      preLoaderRoute: typeof AuthWorkforceDepartmentsDepartmentIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/financial/dre/drilldown/$lineItem': {
      id: '/_auth/financial/dre/drilldown/$lineItem'
      path: '/dre/drilldown/$lineItem'
      fullPath: '/financial/dre/drilldown/$lineItem'
      preLoaderRoute: typeof AuthFinancialDreDrilldownLineItemRouteImport
      parentRoute: typeof AuthFinancialRoute
    }
  }
}

interface AuthFinancialRouteChildren {
  AuthFinancialAccountsPayableRoute: typeof AuthFinancialAccountsPayableRoute
  AuthFinancialAccountsReceivableRoute: typeof AuthFinancialAccountsReceivableRoute
  AuthFinancialBigNumbersRoute: typeof AuthFinancialBigNumbersRoute
  AuthFinancialClientDetailRoute: typeof AuthFinancialClientDetailRoute
  AuthFinancialClientDetailInteractiveRoute: typeof AuthFinancialClientDetailInteractiveRoute
  AuthFinancialClientMatrixInteractiveRoute: typeof AuthFinancialClientMatrixInteractiveRoute
  AuthFinancialClientMatrixMockRoute: typeof AuthFinancialClientMatrixMockRoute
  AuthFinancialDashboardRoute: typeof AuthFinancialDashboardRoute
  AuthFinancialPerformanceClientesRoute: typeof AuthFinancialPerformanceClientesRoute
  AuthFinancialProaRoute: typeof AuthFinancialProaRoute
  AuthFinancialIndexRoute: typeof AuthFinancialIndexRoute
  AuthFinancialBuMatrixBuIdRoute: typeof AuthFinancialBuMatrixBuIdRoute
  AuthFinancialClientMatrixClientIdRoute: typeof AuthFinancialClientMatrixClientIdRoute
  AuthFinancialBuMatrixIndexRoute: typeof AuthFinancialBuMatrixIndexRoute
  AuthFinancialClientMatrixIndexRoute: typeof AuthFinancialClientMatrixIndexRoute
  AuthFinancialDreIndexRoute: typeof AuthFinancialDreIndexRoute
  AuthFinancialDreDrilldownLineItemRoute: typeof AuthFinancialDreDrilldownLineItemRoute
}

const AuthFinancialRouteChildren: AuthFinancialRouteChildren = {
  AuthFinancialAccountsPayableRoute: AuthFinancialAccountsPayableRoute,
  AuthFinancialAccountsReceivableRoute: AuthFinancialAccountsReceivableRoute,
  AuthFinancialBigNumbersRoute: AuthFinancialBigNumbersRoute,
  AuthFinancialClientDetailRoute: AuthFinancialClientDetailRoute,
  AuthFinancialClientDetailInteractiveRoute:
    AuthFinancialClientDetailInteractiveRoute,
  AuthFinancialClientMatrixInteractiveRoute:
    AuthFinancialClientMatrixInteractiveRoute,
  AuthFinancialClientMatrixMockRoute: AuthFinancialClientMatrixMockRoute,
  AuthFinancialDashboardRoute: AuthFinancialDashboardRoute,
  AuthFinancialPerformanceClientesRoute: AuthFinancialPerformanceClientesRoute,
  AuthFinancialProaRoute: AuthFinancialProaRoute,
  AuthFinancialIndexRoute: AuthFinancialIndexRoute,
  AuthFinancialBuMatrixBuIdRoute: AuthFinancialBuMatrixBuIdRoute,
  AuthFinancialClientMatrixClientIdRoute:
    AuthFinancialClientMatrixClientIdRoute,
  AuthFinancialBuMatrixIndexRoute: AuthFinancialBuMatrixIndexRoute,
  AuthFinancialClientMatrixIndexRoute: AuthFinancialClientMatrixIndexRoute,
  AuthFinancialDreIndexRoute: AuthFinancialDreIndexRoute,
  AuthFinancialDreDrilldownLineItemRoute:
    AuthFinancialDreDrilldownLineItemRoute,
}

const AuthFinancialRouteWithChildren = AuthFinancialRoute._addFileChildren(
  AuthFinancialRouteChildren,
)

interface AuthSigRouteChildren {
  AuthSigClientsIndexRoute: typeof AuthSigClientsIndexRoute
}

const AuthSigRouteChildren: AuthSigRouteChildren = {
  AuthSigClientsIndexRoute: AuthSigClientsIndexRoute,
}

const AuthSigRouteWithChildren =
  AuthSigRoute._addFileChildren(AuthSigRouteChildren)

interface AuthDocumentsIdRouteChildren {
  AuthDocumentsIdAuditRoute: typeof AuthDocumentsIdAuditRoute
}

const AuthDocumentsIdRouteChildren: AuthDocumentsIdRouteChildren = {
  AuthDocumentsIdAuditRoute: AuthDocumentsIdAuditRoute,
}

const AuthDocumentsIdRouteWithChildren = AuthDocumentsIdRoute._addFileChildren(
  AuthDocumentsIdRouteChildren,
)

interface AuthUsersIdRouteChildren {
  AuthUsersIdEditRoute: typeof AuthUsersIdEditRoute
}

const AuthUsersIdRouteChildren: AuthUsersIdRouteChildren = {
  AuthUsersIdEditRoute: AuthUsersIdEditRoute,
}

const AuthUsersIdRouteWithChildren = AuthUsersIdRoute._addFileChildren(
  AuthUsersIdRouteChildren,
)

interface AuthRouteChildren {
  AuthAvailableBudgetRoute: typeof AuthAvailableBudgetRoute
  AuthCalendarRoute: typeof AuthCalendarRoute
  AuthComponentShowcaseRoute: typeof AuthComponentShowcaseRoute
  AuthConfigRoute: typeof AuthConfigRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthEmployeesRoute: typeof AuthEmployeesRoute
  AuthFinancialRoute: typeof AuthFinancialRouteWithChildren
  AuthJanesRoute: typeof AuthJanesRoute
  AuthMetasGestaoRoute: typeof AuthMetasGestaoRoute
  AuthMyBusinessTargetsRoute: typeof AuthMyBusinessTargetsRoute
  AuthMyCoursesRoute: typeof AuthMyCoursesRoute
  AuthMyEvaluationRoute: typeof AuthMyEvaluationRoute
  AuthMyOnboardingRoute: typeof AuthMyOnboardingRoute
  AuthMyTeamRoute: typeof AuthMyTeamRoute
  AuthOrgchartRoute: typeof AuthOrgchartRoute
  AuthPeopleRoute: typeof AuthPeopleRoute
  AuthProfileRoute: typeof AuthProfileRoute
  AuthProjectionsRoute: typeof AuthProjectionsRoute
  AuthReportsRoute: typeof AuthReportsRoute
  AuthResultsRoute: typeof AuthResultsRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthSigRoute: typeof AuthSigRouteWithChildren
  AuthSignDocumentsRoute: typeof AuthSignDocumentsRoute
  AuthTeamCoursesRoute: typeof AuthTeamCoursesRoute
  AuthTeamEvaluationRoute: typeof AuthTeamEvaluationRoute
  AuthThemePreviewRoute: typeof AuthThemePreviewRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthDesignSystemAnalyticsDashboardRoute: typeof AuthDesignSystemAnalyticsDashboardRoute
  AuthDesignSystemAnalyticsShowcaseRoute: typeof AuthDesignSystemAnalyticsShowcaseRoute
  AuthDocumentsIdRoute: typeof AuthDocumentsIdRouteWithChildren
  AuthGroupsGroupIdRoute: typeof AuthGroupsGroupIdRoute
  AuthMeetingsScheduleRoute: typeof AuthMeetingsScheduleRoute
  AuthNotificationsPreferencesRoute: typeof AuthNotificationsPreferencesRoute
  AuthOnboardingIdRoute: typeof AuthOnboardingIdRoute
  AuthPerformanceClimaRoute: typeof AuthPerformanceClimaRoute
  AuthPerformanceGuiaRoute: typeof AuthPerformanceGuiaRoute
  AuthPerformanceIndividualRoute: typeof AuthPerformanceIndividualRoute
  AuthPerformanceNewRoute: typeof AuthPerformanceNewRoute
  AuthPerformanceOkrsRoute: typeof AuthPerformanceOkrsRoute
  AuthRecruitmentNewRoute: typeof AuthRecruitmentNewRoute
  AuthRevfinopsPayablesRoute: typeof AuthRevfinopsPayablesRoute
  AuthTrainingNewRoute: typeof AuthTrainingNewRoute
  AuthUsersIdRoute: typeof AuthUsersIdRouteWithChildren
  AuthVacationApprovalsRoute: typeof AuthVacationApprovalsRoute
  AuthVacationCalendarRoute: typeof AuthVacationCalendarRoute
  AuthVacationOverviewRoute: typeof AuthVacationOverviewRoute
  AuthVacationRequestRoute: typeof AuthVacationRequestRoute
  AuthVacationRequestsRoute: typeof AuthVacationRequestsRoute
  AuthWorkforceAuditLogsRoute: typeof AuthWorkforceAuditLogsRoute
  AuthWorkforcePayrollRoute: typeof AuthWorkforcePayrollRoute
  AuthClientsIndexRoute: typeof AuthClientsIndexRoute
  AuthDocumentsIndexRoute: typeof AuthDocumentsIndexRoute
  AuthOnboardingIndexRoute: typeof AuthOnboardingIndexRoute
  AuthPerformanceIndexRoute: typeof AuthPerformanceIndexRoute
  AuthRecruitmentIndexRoute: typeof AuthRecruitmentIndexRoute
  AuthRevfinopsIndexRoute: typeof AuthRevfinopsIndexRoute
  AuthTrainingIndexRoute: typeof AuthTrainingIndexRoute
  AuthVacationIndexRoute: typeof AuthVacationIndexRoute
  AuthClientsClientCodeDashboardRoute: typeof AuthClientsClientCodeDashboardRoute
  AuthPerformanceAvaliacoesFormRoute: typeof AuthPerformanceAvaliacoesFormRoute
  AuthPerformanceConfiguracoesMatrizRoute: typeof AuthPerformanceConfiguracoesMatrizRoute
  AuthPerformanceConfiguracoesParametrosRoute: typeof AuthPerformanceConfiguracoesParametrosRoute
  AuthPerformanceFeedbacksCompleteRoute: typeof AuthPerformanceFeedbacksCompleteRoute
  AuthPerformanceFeedbacksQuickRoute: typeof AuthPerformanceFeedbacksQuickRoute
  AuthPerformanceFeedbacksReceivedRoute: typeof AuthPerformanceFeedbacksReceivedRoute
  AuthRevfinopsClientsNewRoute: typeof AuthRevfinopsClientsNewRoute
  AuthTemplatesIdUseRoute: typeof AuthTemplatesIdUseRoute
  AuthWorkforceDepartmentsNewRoute: typeof AuthWorkforceDepartmentsNewRoute
  AuthWorkforceEmployeesNewRoute: typeof AuthWorkforceEmployeesNewRoute
  AuthWorkforceRolesNewRoute: typeof AuthWorkforceRolesNewRoute
  AuthPerformanceAvaliacoesIndexRoute: typeof AuthPerformanceAvaliacoesIndexRoute
  AuthPerformanceConfiguracoesIndexRoute: typeof AuthPerformanceConfiguracoesIndexRoute
  AuthPerformanceFeedbacksIndexRoute: typeof AuthPerformanceFeedbacksIndexRoute
  AuthRevfinopsClientsIndexRoute: typeof AuthRevfinopsClientsIndexRoute
  AuthWorkforceDepartmentsIndexRoute: typeof AuthWorkforceDepartmentsIndexRoute
  AuthWorkforceEmployeesIndexRoute: typeof AuthWorkforceEmployeesIndexRoute
  AuthWorkforceRolesIndexRoute: typeof AuthWorkforceRolesIndexRoute
  AuthWorkforceDepartmentsDepartmentIdEditRoute: typeof AuthWorkforceDepartmentsDepartmentIdEditRoute
  AuthWorkforceEmployeesEmployeeIdEditRoute: typeof AuthWorkforceEmployeesEmployeeIdEditRoute
  AuthWorkforceRolesRoleIdEditRoute: typeof AuthWorkforceRolesRoleIdEditRoute
  AuthWorkforceDepartmentsDepartmentIdIndexRoute: typeof AuthWorkforceDepartmentsDepartmentIdIndexRoute
  AuthWorkforceEmployeesEmployeeIdIndexRoute: typeof AuthWorkforceEmployeesEmployeeIdIndexRoute
  AuthWorkforceRolesRoleIdIndexRoute: typeof AuthWorkforceRolesRoleIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAvailableBudgetRoute: AuthAvailableBudgetRoute,
  AuthCalendarRoute: AuthCalendarRoute,
  AuthComponentShowcaseRoute: AuthComponentShowcaseRoute,
  AuthConfigRoute: AuthConfigRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthEmployeesRoute: AuthEmployeesRoute,
  AuthFinancialRoute: AuthFinancialRouteWithChildren,
  AuthJanesRoute: AuthJanesRoute,
  AuthMetasGestaoRoute: AuthMetasGestaoRoute,
  AuthMyBusinessTargetsRoute: AuthMyBusinessTargetsRoute,
  AuthMyCoursesRoute: AuthMyCoursesRoute,
  AuthMyEvaluationRoute: AuthMyEvaluationRoute,
  AuthMyOnboardingRoute: AuthMyOnboardingRoute,
  AuthMyTeamRoute: AuthMyTeamRoute,
  AuthOrgchartRoute: AuthOrgchartRoute,
  AuthPeopleRoute: AuthPeopleRoute,
  AuthProfileRoute: AuthProfileRoute,
  AuthProjectionsRoute: AuthProjectionsRoute,
  AuthReportsRoute: AuthReportsRoute,
  AuthResultsRoute: AuthResultsRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthSigRoute: AuthSigRouteWithChildren,
  AuthSignDocumentsRoute: AuthSignDocumentsRoute,
  AuthTeamCoursesRoute: AuthTeamCoursesRoute,
  AuthTeamEvaluationRoute: AuthTeamEvaluationRoute,
  AuthThemePreviewRoute: AuthThemePreviewRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthDesignSystemAnalyticsDashboardRoute:
    AuthDesignSystemAnalyticsDashboardRoute,
  AuthDesignSystemAnalyticsShowcaseRoute:
    AuthDesignSystemAnalyticsShowcaseRoute,
  AuthDocumentsIdRoute: AuthDocumentsIdRouteWithChildren,
  AuthGroupsGroupIdRoute: AuthGroupsGroupIdRoute,
  AuthMeetingsScheduleRoute: AuthMeetingsScheduleRoute,
  AuthNotificationsPreferencesRoute: AuthNotificationsPreferencesRoute,
  AuthOnboardingIdRoute: AuthOnboardingIdRoute,
  AuthPerformanceClimaRoute: AuthPerformanceClimaRoute,
  AuthPerformanceGuiaRoute: AuthPerformanceGuiaRoute,
  AuthPerformanceIndividualRoute: AuthPerformanceIndividualRoute,
  AuthPerformanceNewRoute: AuthPerformanceNewRoute,
  AuthPerformanceOkrsRoute: AuthPerformanceOkrsRoute,
  AuthRecruitmentNewRoute: AuthRecruitmentNewRoute,
  AuthRevfinopsPayablesRoute: AuthRevfinopsPayablesRoute,
  AuthTrainingNewRoute: AuthTrainingNewRoute,
  AuthUsersIdRoute: AuthUsersIdRouteWithChildren,
  AuthVacationApprovalsRoute: AuthVacationApprovalsRoute,
  AuthVacationCalendarRoute: AuthVacationCalendarRoute,
  AuthVacationOverviewRoute: AuthVacationOverviewRoute,
  AuthVacationRequestRoute: AuthVacationRequestRoute,
  AuthVacationRequestsRoute: AuthVacationRequestsRoute,
  AuthWorkforceAuditLogsRoute: AuthWorkforceAuditLogsRoute,
  AuthWorkforcePayrollRoute: AuthWorkforcePayrollRoute,
  AuthClientsIndexRoute: AuthClientsIndexRoute,
  AuthDocumentsIndexRoute: AuthDocumentsIndexRoute,
  AuthOnboardingIndexRoute: AuthOnboardingIndexRoute,
  AuthPerformanceIndexRoute: AuthPerformanceIndexRoute,
  AuthRecruitmentIndexRoute: AuthRecruitmentIndexRoute,
  AuthRevfinopsIndexRoute: AuthRevfinopsIndexRoute,
  AuthTrainingIndexRoute: AuthTrainingIndexRoute,
  AuthVacationIndexRoute: AuthVacationIndexRoute,
  AuthClientsClientCodeDashboardRoute: AuthClientsClientCodeDashboardRoute,
  AuthPerformanceAvaliacoesFormRoute: AuthPerformanceAvaliacoesFormRoute,
  AuthPerformanceConfiguracoesMatrizRoute:
    AuthPerformanceConfiguracoesMatrizRoute,
  AuthPerformanceConfiguracoesParametrosRoute:
    AuthPerformanceConfiguracoesParametrosRoute,
  AuthPerformanceFeedbacksCompleteRoute: AuthPerformanceFeedbacksCompleteRoute,
  AuthPerformanceFeedbacksQuickRoute: AuthPerformanceFeedbacksQuickRoute,
  AuthPerformanceFeedbacksReceivedRoute: AuthPerformanceFeedbacksReceivedRoute,
  AuthRevfinopsClientsNewRoute: AuthRevfinopsClientsNewRoute,
  AuthTemplatesIdUseRoute: AuthTemplatesIdUseRoute,
  AuthWorkforceDepartmentsNewRoute: AuthWorkforceDepartmentsNewRoute,
  AuthWorkforceEmployeesNewRoute: AuthWorkforceEmployeesNewRoute,
  AuthWorkforceRolesNewRoute: AuthWorkforceRolesNewRoute,
  AuthPerformanceAvaliacoesIndexRoute: AuthPerformanceAvaliacoesIndexRoute,
  AuthPerformanceConfiguracoesIndexRoute:
    AuthPerformanceConfiguracoesIndexRoute,
  AuthPerformanceFeedbacksIndexRoute: AuthPerformanceFeedbacksIndexRoute,
  AuthRevfinopsClientsIndexRoute: AuthRevfinopsClientsIndexRoute,
  AuthWorkforceDepartmentsIndexRoute: AuthWorkforceDepartmentsIndexRoute,
  AuthWorkforceEmployeesIndexRoute: AuthWorkforceEmployeesIndexRoute,
  AuthWorkforceRolesIndexRoute: AuthWorkforceRolesIndexRoute,
  AuthWorkforceDepartmentsDepartmentIdEditRoute:
    AuthWorkforceDepartmentsDepartmentIdEditRoute,
  AuthWorkforceEmployeesEmployeeIdEditRoute:
    AuthWorkforceEmployeesEmployeeIdEditRoute,
  AuthWorkforceRolesRoleIdEditRoute: AuthWorkforceRolesRoleIdEditRoute,
  AuthWorkforceDepartmentsDepartmentIdIndexRoute:
    AuthWorkforceDepartmentsDepartmentIdIndexRoute,
  AuthWorkforceEmployeesEmployeeIdIndexRoute:
    AuthWorkforceEmployeesEmployeeIdIndexRoute,
  AuthWorkforceRolesRoleIdIndexRoute: AuthWorkforceRolesRoleIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicSTokenRoute: typeof PublicSTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSTokenRoute: PublicSTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface UnauthRouteChildren {
  UnauthLoginRoute: typeof UnauthLoginRoute
  UnauthRegisterRoute: typeof UnauthRegisterRoute
}

const UnauthRouteChildren: UnauthRouteChildren = {
  UnauthLoginRoute: UnauthLoginRoute,
  UnauthRegisterRoute: UnauthRegisterRoute,
}

const UnauthRouteWithChildren =
  UnauthRoute._addFileChildren(UnauthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  UnauthRoute: UnauthRouteWithChildren,
  ErrorRoute: ErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
